import axios from 'axios'
import { getHeader, inventoryUrl } from '../config'

const state = {
  inventoryApproveList: [],
  inventoryTypeList: [],
  inventory: {},
  onHandProductList: [],
  onHandList: [],
  onHandDetail: {
    manufactures: []
  }
}

const mutations = {
  SET_INVENTORY_APPROVE_LIST (state, obj) {
    state.inventoryApproveList = obj
  },
  SET_INVENTORY_TYPE_LIST (state, obj) {
    state.inventoryTypeList = obj
  },
  SET_INVENTORY_BY_NO (state, obj) {
    state.inventory = obj
  },
  SET_INVENTORY_ON_HAND_PRODUCT_LIST (state, obj) {
    state.onHandProductList = obj
  },
  SET_INVENTORY_ON_HAND_LIST (state, obj) {
    state.onHandList = obj
  },
  SET_INVENTORY_ON_HAND_DETAIL (state, obj) {
    state.onHandDetail = obj
  }
}

const actions = {
  getInventoryOnHandDetail: ({ commit }, payload) => {
    console.log(inventoryUrl + '/on-hand/detail/' + payload.id)
    axios.get(inventoryUrl + '/on-hand/detail/' + payload.id, { headers: getHeader() })
      .then(response => {
        commit('SET_INVENTORY_ON_HAND_DETAIL', response.data.data)
      })
  },
  getInventoryOnHandList: ({ commit }, payload) => {
    var url = null
    if (payload.begin === null) {
      url = inventoryUrl + '/on-hand' + '?begin=&end=&company=' + payload.company
    } else {
      url = inventoryUrl + '/on-hand' + '?begin=' + payload.begin + '&end=' + payload.end + '&company=' + payload.company
    }
    console.log(url)
    axios.get(url, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_INVENTORY_ON_HAND_LIST', response.data.data)
      })
  },
  getInventoryApprove: ({ commit }) => {
    axios.get(inventoryUrl + '/status/approve', { headers: getHeader() })
      .then(response => {
        commit('SET_INVENTORY_APPROVE_LIST', response.data.data)
      })
  },
  getInventoryTypeList: ({ commit }) => {
    axios.get(inventoryUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_INVENTORY_TYPE_LIST', response.data.data)
      })
  },
  getInventoryByNo: ({ commit }, payload) => {
    console.log('vuex')
    console.log(payload)
    axios.post(inventoryUrl + '/get-inventory-no', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_INVENTORY_BY_NO', response.data.data)
      })
  },
  getInventoryOnHandProductList: ({ commit }, payload) => {
    var url = inventoryUrl + '/on-hand/product-list?company=' + payload.company
    console.log(url)
    axios.get(url, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_INVENTORY_ON_HAND_PRODUCT_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
